import { render, staticRenderFns } from "./detailCase.vue?vue&type=template&id=5d576981&scoped=true"
import script from "./detailCase.vue?vue&type=script&lang=js"
export * from "./detailCase.vue?vue&type=script&lang=js"
import style0 from "./detailCase.vue?vue&type=style&index=0&id=5d576981&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d576981",
  null
  
)

export default component.exports